/**
 * Arms scroll parallax on a page subtree for as long as it is mounted (and re-arms when `pageKey`
 * changes). Mount it once in the shell next to the scroll reveal, inside the page's Suspense
 * boundary, so it starts after the page has committed. Publishes `window.__omegaParallax`.
 */
import { useEffect, type RefObject } from 'react';
import { ParallaxController } from './controller';

export function useParallax(scope: RefObject<HTMLElement | null>, pageKey: string): void {
  useEffect(() => {
    const root = scope.current;
    if (root === null || typeof window.matchMedia !== 'function') return;
    if (typeof CSS === 'undefined' || !CSS.supports('translate', '0px 10px')) return;
    const controller = new ParallaxController(root);
    const handle = controller.handle();
    Object.defineProperty(window, '__omegaParallax', { value: handle, configurable: true, writable: false });
    return () => {
      if (window.__omegaParallax === handle) delete window.__omegaParallax;
      controller.dispose();
    };
  }, [scope, pageKey]);
}
